import { createI18n } from 'vue-i18n'

import de from './locales/de.json'
import en from './locales/en.json'
import ru from './locales/ru.json'

export type SupportedLocale = 'de' | 'en' | 'ru'

export const SUPPORTED_LOCALES: SupportedLocale[] = ['de', 'en', 'ru']
export const DEFAULT_LOCALE: SupportedLocale = 'de'

function detectInitialLocale(): SupportedLocale {
  const stored = localStorage.getItem('partroom.locale')
  if (stored && (SUPPORTED_LOCALES as string[]).includes(stored)) {
    return stored as SupportedLocale
  }
  const browser = navigator.language.slice(0, 2).toLowerCase()
  if ((SUPPORTED_LOCALES as string[]).includes(browser)) {
    return browser as SupportedLocale
  }
  return DEFAULT_LOCALE
}

const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { de, en, ru }
})

export default i18n
